import { jsx as _jsx } from "react/jsx-runtime";
import { TransitionCondition } from '@app/pathway-shared';
import { ICONS } from '@app/styles';
import './Component_ProtocolStepStatusIndicator.scss';
import { openContent } from '@nu-art/thunderstorm-frontend/index';
import { iconTooltipId } from '../../../../_style/icon-tooltip/index.js';
export const Component_ProtocolStepStatusIndicator = (props) => {
    switch (props.status) {
        case TransitionCondition.GO_TO_TRANSITION:
            return _jsx(ICONS.advisor_v5_transitionPass.component, { className: 'protocol-step-status-indicator', ...openContent.tooltip.top(iconTooltipId, 'Recommended based on patient data', { offset: 8 }) });
        case TransitionCondition.RES_FUNC_FALSE:
        case TransitionCondition.EVAL_FAILURE:
            return _jsx(ICONS.advisor_v5_transitionFail.component, { className: 'protocol-step-status-indicator', ...openContent.tooltip.top(iconTooltipId, 'Not recommended based on patient data', { offset: 8 }) });
        default:
            return _jsx(ICONS.advisor_v5_transitionInsufficient.component, { className: 'protocol-step-status-indicator', ...openContent.tooltip.top(iconTooltipId, 'Insufficient data to recommend', { offset: 8 }) });
    }
};
export const Component_ProtocolStepStatusIndicatorV2 = (props) => {
    switch (props.status) {
        case TransitionCondition.GO_TO_TRANSITION: {
            return _jsx(ICONS.advisor_v5_transitionPassV2.component, { className: 'protocol-step-status-indicator pass', ...openContent.tooltip.top(iconTooltipId, 'Recommended based on patient data', { offset: 8 }) });
        }
        case TransitionCondition.RES_FUNC_FALSE:
        case TransitionCondition.EVAL_FAILURE:
            return _jsx(ICONS.advisor_avn_close.component, { className: 'protocol-step-status-indicator fail', ...openContent.tooltip.top(iconTooltipId, 'Not recommended based on patient data', { offset: 8 }) });
        default:
            return _jsx(ICONS.advisor_v5_transitionInsufficient.component, { className: 'protocol-step-status-indicator general', ...openContent.tooltip.top(iconTooltipId, 'Insufficient data to recommend', { offset: 8 }) });
    }
};
//# sourceMappingURL=Component_ProtocolStepStatusIndicator.js.map